
import FF_Module from './FF_Module'; // eslint-disable-line no-autofix/snakecasejs/snakecasejs
import { ff_ajax } from '../utils/ajax';

/**
 * Module qui gère les éléments ".lazy-load-content" pour les quels le contenu est chargé en différé au scroll selon une limit de publication définit.
 */
export default class FF_Lazy_Load_Content extends FF_Module {

  /***
   *     # #    # # #####
   *     # ##   # #   #
   *     # # #  # #   #
   *     # #  # # #   #
   *     # #    # #   #
   */
  /**
   * Initialise le module.
   */
  init() {

    // Propriétés
    this.load_more_action = $(this.elements.container).attr('data-lazy-load-content-action');
    if (!this.load_more_action) {
      console.error('FF_Lazy_Load_Content: L\'élément ne possède page l\'attribut requis "data-lazy-load-content-action".', this.elements.container);
      return;
    }

    this.limit = parseInt($(this.elements.container).attr('data-lazy-load-content-limit') || 20);
    this.offset = this.limit;

    this.ajax_request = null;
    this.has_more_content = true;
    this.is_loading = false;
    this.scroll_trigger = null;

    this.post_parameters = $(this.elements.container).attr('data-lazy-load-content-post-parameters') ? JSON.parse($(this.elements.container).attr('data-lazy-load-content-post-parameters') || '') : {};
    $(this.elements.container).removeAttr('data-lazy-load-content-post-parameters');

    // Initialisation
    this.setup_scroll_trigger();

  }

  /***
   *      ####  ###### ##### #    # #####      ####   ####  #####   ####  #      #         ##### #####  #  ####   ####  ###### #####
   *     #      #        #   #    # #    #    #      #    # #    # #    # #      #           #   #    # # #    # #    # #      #    #
   *      ####  #####    #   #    # #    #     ####  #      #    # #    # #      #           #   #    # # #      #      #####  #    #
   *          # #        #   #    # #####          # #      #####  #    # #      #           #   #####  # #  ### #  ### #      #####
   *      ####  ######   #    ####  #          ####   ####  #    #  ####  ###### ######      #   #    # #  ####   ####  ###### #    #
   */
  /**
   * Initialise le ScrollTrigger qui déclenche le chargment du contenu.
   */
  setup_scroll_trigger() {
    if (this.scroll_trigger) this.scroll_trigger.kill();
    this.scroll_trigger = ScrollTrigger.create({
      trigger: this.elements.container,
      start  : 'bottom 300%',
      onEnter: this.load_more.bind(this)
    });
  }

  /***
   *     #####  ######  ####  ##### #####   ####  #   #     ####   ####  #####   ####  #      #         ##### #####  #  ####   ####  ###### #####
   *     #    # #      #        #   #    # #    #  # #     #      #    # #    # #    # #      #           #   #    # # #    # #    # #      #    #
   *     #    # #####   ####    #   #    # #    #   #       ####  #      #    # #    # #      #           #   #    # # #      #      #####  #    #
   *     #    # #           #   #   #####  #    #   #           # #      #####  #    # #      #           #   #####  # #  ### #  ### #      #####
   *     #####  ######  ####    #   #    #  ####    #       ####   ####  #    #  ####  ###### ######      #   #    # #  ####   ####  ###### #    #
   */
  /**
   * Détruit le ScrollTrigger actuellement actif.
   */
  destroy_scroll_trigger() {
    if (!this.scroll_trigger) return;
    this.scroll_trigger.kill();
    this.scroll_trigger = null;
  }

  /***
   *     #       ####    ##   #####     #    #  ####  #####  ######
   *     #      #    #  #  #  #    #    ##  ## #    # #    # #
   *     #      #    # #    # #    #    # ## # #    # #    # #####
   *     #      #    # ###### #    #    #    # #    # #####  #
   *     ######  ####  #    # #####     #    #  ####  #    # ######
   */
  /**
   * Charge, en ajax, le prochain contenu et, si disponible, l'ajoute à la fin du conteneur, l'anime, met à jour le offset et initialise on nouveau ScrollTrigger..
   */
  load_more() {

    // ============================================================================================
    // Bail s'il n'y a plus de contenu ou si on est déjà en train de charger le contenu
    // ============================================================================================
    if (!this.has_more_content || this.is_loading || this.is_destroyed) {
      return;
    }

    // ============================================================================================
    // Construit les paramètes de la requête AJAX
    // ============================================================================================
    let url_parameters = new URLSearchParams(window.location.search); // Ajoute les paramètres d'URL aux paramètres de la requête,
    url_parameters = Object.fromEntries(url_parameters.entries());

    const request_data = {
      action: this.load_more_action,
      limit : this.limit,
      offset: this.offset,
      ...url_parameters,
      ...this.post_parameters
    };

    // ============================================================================================
    // Exécute la requête
    // ============================================================================================
    this.is_loading = true;

    this.ajax_request = ff_ajax({
      dataType: 'json',
      data    : request_data,
      complete: () => {
        this.is_loading = false;
        this.ajax_request = null;
      },
      error: () => {
        this.destroy_scroll_trigger();
      },
      success: ({ data }) => {

        // Bail si l'instance à été détruite
        if (this.destroyed) {
          return;
        }

        // Bail, si, for some reason, l'élément n'est plus dans le DOM
        if (!document.body.contains(this.elements.container)) {
          this.destroy();
          return;
        }

        // Bail s'il n'y a plus de contenu
        if (!data.results) {
          this.has_more_content = false;
          this.destroy_scroll_trigger();
          return;
        }

        // Animation et ajout du nouveau contenu au DOM
        const $results = $(data.results);
        gsap.set($results, { opacity: 0 });
        $(this.elements.container).append($results);
        ScrollTrigger.getAll().forEach((sc) => {
          sc.refresh();
        });
        if (ff_scroll.scrollbar) ff_scroll.scrollbar.refresh();
        if (is_mobile || limit_animations) {
          gsap.fromTo($results, { opacity: 0 }, { opacity: 1, duration: 1.4, ease: 'expo.out', clearProps: 'opacity', overwrite: true });
        }
        else {
          gsap.fromTo($results, { y: '6.5rem', opacity: 0 }, { y: 0, opacity: 1, duration: 1.8, ease: 'expo.out', clearProps: 'transform,opacity', overwrite: true });
        }

        // Modifications aux éléments
        ff_update_article_cards_titles_font_size();

        // Met à jour les valeurs requises
        this.offset += this.limit;
        this.setup_scroll_trigger();

      }
    });

  }

  /***
 *     #####  ######  ####  ##### #####   ####  #   #
 *     #    # #      #        #   #    # #    #  # #
 *     #    # #####   ####    #   #    # #    #   #
 *     #    # #           #   #   #####  #    #   #
 *     #####  ######  ####    #   #    #  ####    #
 */
  /**
   * Détruit l'instance en réinitialisant les changements apportés à l'élément principal, en annulant la requête AJAX, si nécéssaiee et en détruisant le ScrollTrigger actuellement actif.
   */
  destroy() {
    if (this.ajax_request) {
      this.ajax_request.abort();
      this.ajax_request = null;
    }
    this.destroy_scroll_trigger();
    super.destroy();
  }

}
